export default "__VITE_ASSET__DtJy1BPs__"